<div class="team-cell card-shadow">
  <a class="team-info" appClearHref [href]="getTeamLink(team)">
    <img class="team-crest" [src]="team.getLogoImageUrl('medium')" alt="">
    <p class="team-name">{{ team.name }}</p>
  </a>
  <ng-container *ngIf="userIsFanOf(team.id); else showFollowButton">
    <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Mehr">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="onUnFollowTeamClick(team.id)">
        <span>Nicht mehr folgen</span>
      </button>
    </mat-menu>
  </ng-container>
  <ng-template #showFollowButton>
    <button class="d-none d-md-block"
            mat-stroked-button
            (click)="onFollowTeamClick(team.id)">
      <mat-icon>favorite</mat-icon>
      Team folgen
    </button>
    <button class="btn-outlined d-block d-md-none" mat-stroked-button
            (click)="onFollowTeamClick(team.id)">
      <mat-icon>favorite</mat-icon>
      Folgen
    </button>
  </ng-template>
</div>
